/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { indexesDelete } from "../../funcs/indexesDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteIndexRequest$inboundSchema,
};

export const tool$indexesDelete: ToolDefinition<typeof args> = {
  name: "indexes-delete",
  description: `Delete an index

Delete a specific index by providing its unique identifier.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await indexesDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
